export const GET_TEACHERS_REQUEST = 'GET_TEACHERS_REQUEST'
export const GET_TEACHERS_SUCCESS = 'GET_TEACHERS_SUCCESS'
export const GET_TEACHER_SUCCESS = 'GET_TEACHER_SUCCESS'
// Materias
export const GET_TEACHER_MATERIAS = 'GET_TEACHER_MATERIAS'
export const GET_ALL_TEACHER_MATERIAS = 'GET_ALL_TEACHER_MATERIAS'
export const RESET_TEACHER_MATERIAS = 'RESET_TEACHER_MATERIAS'
export const GET_TEACHERS_FAIL = 'GET_TEACHERS_USER_FAIL'
// Edit
export const EDIT_TEACHER_SUCCESS = 'EDIT_TEACHER_SUCCESS'
